export default __webpack_public_path__ + "static/media/problema-08.8a869b51.webp";